const s = "styles-module__progress___SOINB", e = "styles-module__progress_sector___5-JNo", _ = "styles-module__progress_sector_active___Mbge3", r = "styles-module__progress_sector_finished___DZY-W", o = {
  progress: s,
  progress_sector: e,
  progress_sector_active: _,
  progress_sector_finished: r
};
export {
  o as default,
  s as progress,
  e as progress_sector,
  _ as progress_sector_active,
  r as progress_sector_finished
};
